import { render, staticRenderFns } from "./ArrowRight.vue?vue&type=template&id=3478a4c4"
var script = {}
import style0 from "./ArrowRight.vue?vue&type=style&index=0&id=3478a4c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports